
    import I18n from 'i18nObj';
    
      import 'translations/change_points_possible_to_match_rubric_dialog';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('change_points_possible_to_match_rubric_dialog');
  